import { keyframes } from "styled-components";
export const createSlideAnimation = (x, y, fadeIn = false) => keyframes `
    from {
        transform: translate(${x}, ${y});
        ${fadeIn ? "opacity: 0;" : ""}
    }
    to {
        transform: translate(0, 0);
        ${fadeIn ? "opacity: 1;" : ""}
    }
`;
export const createHorizontalSlideAnimation = (distance, fadeIn = false) => keyframes `
    from {
        transform: translateX(${distance});
        ${fadeIn ? "opacity: 0;" : ""}
    }
    to {
        transform: translateX(0);
        ${fadeIn ? "opacity: 1;" : ""}
    }
`;
export const createVerticalSlideAnimation = (distance, fadeIn = false) => keyframes `
    from {
        transform: translateY(${distance});
        ${fadeIn ? "opacity: 0;" : ""}
    }
    to {
        transform: translateY(0);
        ${fadeIn ? "opacity: 1;" : ""}
    }
`;
export const createFadeInAnimation = (fromOpacity, toOpacity) => keyframes `
    from {
        opacity: ${fromOpacity};
    }
    to {
        opacity: ${toOpacity};
    }
`;
